import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './LandingChip.module.css';

type Props = {
  children?: ReactNode;
  size?: 'medium' | 'large';
  preset?: 'landing' | 'club';
};

export function LandingChip({
  children,
  size = 'medium',
  preset = 'landing',
}: Props) {
  return (
    <span
      className={cx(
        styles.root,
        styles[`size_${size}`],
        styles[`preset_${preset}`],
      )}
    >
      {children}
    </span>
  );
}
